import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';
import FifaCard from './FifaCard';
import '../css/CommunityClips.css';

const API_URL = process.env.REACT_APP_API_URL;

export default function CommunityClips() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [clips, setClips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sort, setSort] = useState('top');
  const [error, setError] = useState('');
  const [commentText, setCommentText] = useState({});

  const fetchClips = async (s = sort) => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.get(`${API_URL}/api/community/list?sort=${s}`);
      setClips(res.data || []);
    } catch (e) {
      console.error(e);
      setError('Klipler alınamadı.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClips(sort);
  }, [sort]);

  const toggleLike = async (clipId, idx) => {
    if (!user) return alert('Beğenmek için giriş yapın.');
    try {
      const res = await axios.post(
        `${API_URL}/api/community/${clipId}/like`,
        {},
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      const updated = [...clips];
      updated[idx] = { ...updated[idx], likes: res.data.likes };
      setClips(updated);
    } catch (e) {
      console.error(e);
      alert('Beğeni işlemi başarısız.');
    }
  };

  const addComment = async (clipId) => {
    if (!user) return alert('Yorum yapmak için giriş yapın.');
    const text = commentText[clipId];
    if (!text?.trim()) return;

    try {
      const res = await axios.post(
        `${API_URL}/api/community/${clipId}/comment`,
        { text },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      const updated = clips.map((c) =>
        c._id === clipId ? { ...c, comments: res.data } : c
      );
      setClips(updated);
      setCommentText({ ...commentText, [clipId]: '' });
    } catch (e) {
      console.error(e);
      alert('Yorum eklenemedi.');
    }
  };

  return (
    <div className="container my-5 community-wrapper">
      <div className="text-center mb-5">
        <h1 className="text-success fw-bold mb-3">⚽ En İyi Goller</h1>
        <p className="text-muted mb-4 fs-5">
          Halısahacım kullanıcılarının en çok beğenilen gollerini izleyin!  
          Siz de golünüzü yükleyin, haftanın en iyileri arasına girin ve sürpriz hediyeler kazanın 🎁
        </p>
        <button
          onClick={() => navigate('/community/upload')}
          className="btn btn-lg btn-success shadow-sm rounded-pill px-4 py-2"
        >
          🟢 Golünü Yükle
        </button>
      </div>

      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="text-success m-0">Tüm Klipler</h4>
        <div className="d-flex gap-2">
          <button
            className={`btn btn-sm ${sort === 'top' ? 'btn-success' : 'btn-outline-success'}`}
            onClick={() => setSort('top')}
          >
            🔝 En Popüler
          </button>
          <button
            className={`btn btn-sm ${sort === 'new' ? 'btn-success' : 'btn-outline-success'}`}
            onClick={() => setSort('new')}
          >
            🆕 En Yeni
          </button>
        </div>
      </div>

      {loading && <p>Yükleniyor...</p>}
      {error && <p className="text-danger">{error}</p>}
      {!loading && clips.length === 0 && <p>Henüz klip yok.</p>}

      {clips.map((c, idx) => (
        <div key={c._id} className="community-card">
          {/* 🟢 Sol: FifaCard */}
          <div
            className="fifa-side clickable-card"
            onClick={() => navigate(`/user/${c.uploader?._id}`)}
            title={`${c.uploader?.fullName} profiline git`}
          >
            {c.uploader ? (
                <FifaCard
                    user={{
                        ...c.uploader,
                        imageUrl: c.uploader.photo
                        ? `${API_URL}/${c.uploader.photo.startsWith('uploads/') ? c.uploader.photo : 'uploads/' + c.uploader.photo}`
                        : c.uploader.imageUrl
                    }}
                    positionName={c.uploader.position}
                    variant="default"
                />
            ) : (
              <div className="text-muted small">Oyuncu bilgisi yok</div>
            )}
          </div>

          {/* 🎥 Sağ: Video */}
          <div className="video-side">
            <video
              controls
              playsInline
              className="community-video"
            >
              <source src={c.url} type="video/mp4" />
            </video>

            <div className="d-flex align-items-center justify-content-between mt-2">
              <span className="small text-success fw-semibold">
                👍 {c.likes} beğeni
              </span>
              <button
                className="btn btn-outline-success btn-sm"
                onClick={() => toggleLike(c._id, idx)}
                disabled={!user}
              >
                Beğen
              </button>
            </div>

            <hr className="my-2" />

            <div className="comments-area">
              <h6 className="text-success mb-2">💬 Yorumlar</h6>
                <div className="comments-list">
                    {c.comments?.length > 0 ? (
                        c.comments.map((cm, i) => (
                        <div key={i} className="d-flex align-items-start mb-2">
                            {cm.user?.photo || cm.user?.imageUrl ? (
                            <img
                                src={`${API_URL}/${cm.user.photo?.startsWith('uploads/') ? cm.user.photo : cm.user.imageUrl}`}
                                alt="Yorumcu"
                                className="comment-avatar me-2"
                            />
                            ) : (
                            <div className="comment-avatar-placeholder me-2">👤</div>
                            )}
                            <div>
                            <p className="small mb-1">
                                <strong>{cm.user?.fullName || 'Anonim'}:</strong> {cm.text}
                            </p>
                            </div>
                        </div>
                        ))
                    ) : (
                        <p className="small text-muted">Henüz yorum yok.</p>
                    )}
                </div>

              {user && (
                <div className="input-group input-group-sm mt-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Yorum yaz..."
                    value={commentText[c._id] || ''}
                    onChange={(e) =>
                      setCommentText({ ...commentText, [c._id]: e.target.value })
                    }
                  />
                  <button
                    className="btn btn-success"
                    onClick={() => addComment(c._id)}
                  >
                    Gönder
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
